import { normalizeStrokeWidth } from './utils/normalizeStrokeWidth.js';
import { jsx } from 'react/jsx-runtime';
import { SVG } from '../utils/style.svg.js';

const PM2SentenceIcon = ({
  color = "currentColor",
  strokeWidth = 1.5,
  ...svgProps
}) => {
  return /*#__PURE__*/jsx(SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    ...svgProps,
    viewBox: "0 0 47.584 47.5",
    fill: "none",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: normalizeStrokeWidth(strokeWidth, 47.584),
    children: /*#__PURE__*/jsx("path", {
      d: "M25.25 1.25A20.97 20.97 0 007.416 33.3L1.25 46.25l12.95-6.166A21 21 0 1025.25 1.25zM17.505 18.25h16.039M17.505 26.25h16.039"
    })
  });
};

export { PM2SentenceIcon };
//# sourceMappingURL=sentence.js.map
